import { createSlice } from "@reduxjs/toolkit";

export const generalModals = createSlice({
  name: "generalModals",
  initialState: {
    alertModalData: {
      header: "",
      text: "",
      isShown: false,
    },
    largeTextModalData: {
      isShown:false,
    }
  },
  reducers: {
    UpdateAlertModalData(state, action) {
      state.alertModalData = action.payload;
    },
    UpdateLargeTextModalData(state, action) {
      state.largeTextModalData = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { UpdateAlertModalData, UpdateLargeTextModalData, UpdateSuccessModalData } = generalModals.actions;

export default generalModals.reducer;
